import React, {useEffect, useState} from 'react';
import {useFormik} from 'formik'
import {Alert, Button, Popconfirm, Radio, Select, Skeleton, Switch} from "antd";
import {
    useApiDeleteAdminPollSurvey,
    useApiReadAdminPollSurvey,
    useApiUpdateAdminPollSurvey,
    useApiUpdateAdminPollSurveyRelated
} from "@/api/survey";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {URLS} from "@/lib/urls";
import {useNavigate, useParams} from "react-router-dom";
import TaggableSelect from "@/components/select/apiSelect";
import {useApiSearchAdminGroups} from "@/api/group";
import toFaNumber from "@/lib/utils/number";
import {useApiSearchAdminTopics} from "@/api/topic";
import {useApiSearchAdminGrades} from "@/api/grade";
import {useApiSearchAminCourses} from "@/api/course";
import SettingItem from "@/components/setting/settingItem";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";

export const activeRelated = [

    {label: 'همه', value: 'all'}, {label: 'گروه علمی', value: 'group'}, {
        label: 'مقطع تحصیلی',
        value: 'grade'
    }, {label: 'رشته تحصیلی', value: 'course'}, {label: 'سرفصل', value: 'topic'},


];

function SurveySettingSection() {

    const param = useParams()
    const id = param.id;

    const [forSelectedOption, setForSelectedOption] = useState('student')
    const [randomQuestion, setRandomQuestion] = useState(false)
    const [eventType, setEventType] = useState('certificate')

    const [activeRelatedSelect, setActiveRelatedSelect] = useState('all')
    const [activeGenderSelection, setActiveGenderSelection] = useState('both')

    const [groups, setGroups] = useState([])
    const [grades, setGrades] = useState([])
    const [courses, setCourses] = useState([])
    const [topics, setTopics] = useState([])
    const [lessons, setLessons] = useState([])

    const navigate = useNavigate();


    const {data, isPending: isPendingGet} = useApiReadAdminPollSurvey(id)
    const {mutate: editSurvey, isPending: isPendingEdit} = useApiUpdateAdminPollSurvey()
    const {mutate: editSurveyRelated, isPending: isPendingEditRelated} = useApiUpdateAdminPollSurveyRelated()
    const {mutate: deleteSurvey, isPending: isPendingDelete} = useApiDeleteAdminPollSurvey()

    const formik = useFormik({
        initialValues: {}, validate: (values) => {
            return {};
        }, onSubmit: (values) => {


            values.active_related = activeRelatedSelect
            values.active_gender = activeGenderSelection
            values.for = forSelectedOption
            values.event = eventType


            editSurvey({id: id, data: values}, {
                onSuccess: (res) => {


                }, onError: (res) => {
                    ApiHandleErrorMessage(res)
                },
            })

            let related = {
                related: activeRelatedSelect, related_ids: []
            }

            if (activeRelatedSelect === 'topic') {
                related.related_ids = topics
            }

            if (activeRelatedSelect === 'group') {
                related.related_ids = groups
            }

            if (activeRelatedSelect === 'grade') {
                related.related_ids = grades
            }

            if (activeRelatedSelect === 'course') {
                related.related_ids = courses
            }

            if (activeRelatedSelect === 'lesson') {
                related.related_ids = lessons
            }


            editSurveyRelated({id: id, data: related}, {
                onSuccess: (res) => {
                    ApiHandleSuccessMessage(res)
                }, onError: (res) => {
                    ApiHandleErrorMessage(res)
                },
            })

        }
    })


    const isPending = isPendingEdit || isPendingGet;

    useEffect(() => {

        setActiveRelatedSelect(data?.data?.data?.active_related)
        setActiveGenderSelection(data?.data?.data?.active_gender)

        setTopics(data?.data?.data?.related.filter(i => i.related === 'topic').map(j => j.related_id))
        setGroups(data?.data?.data?.related.filter(i => i.related === 'group').map(j => j.related_id))
        setGrades(data?.data?.data?.related.filter(i => i.related === 'grade').map(j => j.related_id))
        setCourses(data?.data?.data?.related.filter(i => i.related === 'course').map(j => j.related_id))
        setLessons(data?.data?.data?.related.filter(i => i.related === 'lesson').map(j => j.related_id))
        setForSelectedOption(data?.data?.data?.for)
        setRandomQuestion(!!data?.data?.data?.random_question)
        setEventType(data?.data?.data?.event || 'certificate')

    }, [data]);

    const activeGender = [

        {label: 'هردو', value: 'both'}, {label: 'آقایان', value: 'male'}, {label: 'بانوان', value: 'female'},

    ];


    const forOption = [{label: 'دانش آموز', value: 'student'}, {label: 'مربی', value: 'teacher'}, {
        label: 'کارشناس',
        value: 'expert'
    },];

    const eventDescriptions = {
        certificate: "این نوع نظرسنجی برای دریافت گواهینامه استفاده می‌شود. کاربران باید به تمام سوالات پاسخ دهند تا گواهینامه دریافت کنند.",
        public: "این نوع نظرسنجی عمومی است و برای جمع‌آوری نظرات عمومی استفاده می‌شود. پاسخ‌دهی به تمام سوالات اجباری نیست."
    };


    const confirmRemove = (e) => {
        deleteSurvey({id: id}, {
            onSuccess: (res) => {
                ApiHandleSuccessMessage(res)
                navigate(URLS.admin.survey.dashboard)
            }, onError: (res) => {
                ApiHandleErrorMessage(res)
            },
        })

    };

    if (isPendingGet) {
        return <Skeleton active/>
    }

    return (<>

            <SettingItem title={'وضعیت انتشار'}
                         description={'در صورتی که وضعیت پیشنویس باشد امکان پاسخ به این نظرسنجی وجود ندارد'}>
                <Switch
                    disabled={isPending}
                    onChange={(e) => formik.setFieldValue("status", e ? 'published' : 'draft')}
                    checkedChildren="منتشر شده" unCheckedChildren="پیش نویس"
                    checked={formik.values.status ? (formik.values.status === 'published') : (data?.data?.data?.status === 'published')}/>
            </SettingItem>

            <SettingItem title={'مخاطب نظرسنجی'} description={'برای کدام دسته از مخاطبان این نظرسنجی فعال شود'}>
                <Radio.Group
                    disabled={isPending}
                    options={forOption} onChange={(e) => setForSelectedOption(e.target.value)}
                    value={forSelectedOption}
                    optionType="button"
                />
            </SettingItem>

            <SettingItem title={'رویداد نمایش نظرسنجی'} description={<Alert
                className="text-sm p-2"
                message={eventType === 'certificate' ? 'نظرسنجی گواهینامه' : 'نظرسنجی عمومی'}
                description={eventDescriptions[eventType]}
                type="info"

            />}>
                <Select
                    disabled={isPending}
                    value={eventType}
                    onChange={(value) => {
                        setEventType(value);
                        formik.setFieldValue('event', value);
                    }}
                    className={'w-12'}
                    style={{width: '150px'}}
                    options={[{label: 'گواهینامه', value: 'certificate'}, {label: 'عمومی', value: 'public'}]}
                />

            </SettingItem>


            {/*<div className={'mt-4 flex-col gap-1'}>*/}
            {/*    <span className={`font-medium ml-1`}></span>*/}
            {/*    <Checkbox*/}
            {/*        disabled={isPending}*/}
            {/*        checked={randomQuestion}*/}
            {/*        onChange={(e) =>*/}
            {/*            setRandomQuestion(e.target.checked)}>نمایش سوالات به صورت تصادفی</Checkbox>*/}

            {/*</div>*/}

            <SettingItem title={'فعال برای جنسیت'} description={''}>
                <Radio.Group
                    disabled={isPending}
                    options={activeGender} onChange={(e) => setActiveGenderSelection(e.target.value)}
                    value={activeGenderSelection}
                    optionType="button"
                />

            </SettingItem>

            <SettingItem title={'فعال برای'} description={<>
                <span>فعال برای گروه یا مقطع یا سرفصل خاص </span>
                <div>
                    {activeRelatedSelect === 'group' && <TaggableSelect name={'topic-search'}
                                                                        label={'فعال برای گروه‌های'}
                                                                        searchFn={useApiSearchAdminGroups}
                                                                        onChange={setGroups}
                                                                        values={groups}
                                                                        render={(item) => {
                                                                            return toFaNumber(item.id) + ' - ' + item.title
                                                                        }}></TaggableSelect>}

                    {activeRelatedSelect === 'grade' && <TaggableSelect name={'topic-search'}
                                                                        label={'فعال برای مقاطع تحصیلی'}
                                                                        searchFn={useApiSearchAdminGrades}
                                                                        onChange={setGrades}
                                                                        values={grades}
                                                                        render={(item) => {
                                                                            return toFaNumber(item.id) + ' - ' + item.title
                                                                        }}></TaggableSelect>}

                    {activeRelatedSelect === 'course' && <TaggableSelect name={'topic-search'}
                                                                         label={'فعال برای رشته تحصیلی'}
                                                                         searchFn={useApiSearchAminCourses}
                                                                         onChange={setCourses}
                                                                         values={courses}
                                                                         render={(item) => {
                                                                             return toFaNumber(item.id) + ' - ' + item.title
                                                                         }}></TaggableSelect>}


                    {activeRelatedSelect === 'topic' && <TaggableSelect name={'topic-search'}
                                                                        label={'فعال برای سرفصل‌های'}
                                                                        searchFn={useApiSearchAdminTopics}
                                                                        onChange={setTopics}
                                                                        values={topics}
                                                                        render={(item) => {
                                                                            return toFaNumber(item.id) + ' - ' + item.title
                                                                        }}></TaggableSelect>}


                </div>
            </>}>
                <Radio.Group
                    disabled={isPending}
                    options={activeRelated} onChange={(e) => setActiveRelatedSelect(e.target.value)}
                    value={activeRelatedSelect}
                    optionType="button"
                />

            </SettingItem>
            <Can permission={PermList.SURVEY_EDIT}>
                <SettingItem title={'ذخیره تغییرات '} description={
                    <Can permission={PermList.SURVEY_DELETE}>
                        <Popconfirm
                            title="حذف نظرسنجی"
                            description="آیا از حذف این نظرسنجی اطمینان دارید"
                            onConfirm={confirmRemove}

                            okText="بله"
                            cancelText="خیر"
                        >
                            <Button loading={isPendingDelete} type={'link'} danger>حذف نظرسنجی</Button>
                        </Popconfirm>
                    </Can>
                }>
                    <Can permission={PermList.SURVEY_EDIT}>

                        <Button onClick={formik.submitForm} type={'primary'} loading={isPendingEdit}
                                disabled={isPendingGet || isPendingDelete}>
                            {'ذخیره تغییرات'}
                        </Button>
                    </Can>
                </SettingItem>
            </Can>
        </>


    )
}

export default SurveySettingSection;


